var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { r as registerInstance, c as createEvent, h, g as getElement, H as Host } from './core-6f498fd9.js';
var CsmSelect = /** @class */ (function () {
    function CsmSelect(hostRef) {
        registerInstance(this, hostRef);
        this.value = null;
        this.csmChange = createEvent(this, "csmChange", 7);
    }
    CsmSelect.prototype.open = function () {
        this.isOpen = true;
        setTimeout(this.scrolToDropdown.bind(this), 100);
    };
    CsmSelect.prototype.close = function () {
        var _this = this;
        setTimeout(function () { return (_this.isOpen = false); });
    };
    CsmSelect.prototype.scrolToDropdown = function () {
        if (this.dropdown) {
            this.dropdown.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    };
    CsmSelect.prototype.onToggle = function () {
        var shouldOpen = !this.disabled && !this.isOpen;
        if (shouldOpen) {
            this.open();
        }
        else {
            this.close();
        }
    };
    CsmSelect.prototype.onItemSelected = function (e) {
        this.changeItem(e.detail.host);
    };
    CsmSelect.prototype.changeItem = function (item) {
        if (this.selectedItem) {
            this.selectedItem.selected = false;
            this.selectedItem = undefined;
        }
        if (item) {
            this.value = item.value;
            this.selectedItem = item;
            this.selectedItem.selected = true;
            this.close();
            this.csmChange.emit(item.value);
        }
        else {
            this.value = undefined;
        }
    };
    CsmSelect.prototype.componentDidUpdate = function () { };
    CsmSelect.prototype.componentWillLoad = function () {
        this.options = __spreadArrays(this.host.querySelectorAll('csm-select-item'));
        this.selectedItem = this.options.find(function (i) { return i.selected; });
        this.value = this.selectedItem && this.selectedItem.value;
    };
    CsmSelect.prototype.componentDidRender = function () {
        if (this.selectedItem) {
            var dropdown = this.selectedItem.parentElement.shadowRoot.querySelector('csm-dropdown-list');
            if (dropdown) {
                dropdown.scrollTop = this.selectedItem.offsetTop - 40;
            }
        }
    };
    CsmSelect.prototype.render = function () {
        var _this = this;
        var displayValue = this.selectedItem && (this.selectedItem.text || this.selectedItem.textContent);
        var elements = [
            h("csm-overlay", { active: this.isOpen, onClick: this.close.bind(this), onCsmOverlayClose: function (e) { return e.stopPropagation(); } }),
            h("input", Object.assign({ part: "csm-select-input", class: "csm-select__input " + (!displayValue ? '' : 'active'), placeholder: this.placeholder, type: "text", value: displayValue }, { disabled: !this.searchable || this.disabled })),
            this.searchable && h("csm-icon", { class: "csm-select__icon csm-select__icon-left", "size-m": true, name: "search" }),
            h("csm-icon", { class: "csm-select__icon csm-select__icon-right", "size-m": true, name: "angle-down", onClick: function () { return _this.onToggle(); } }),
            this.isOpen && h("br", null),
            h("csm-dropdown-list", { style: this.isOpen ? {} : { display: 'none' }, class: "csm-select__dropdown", ref: function (el) {
                    if (el) {
                        _this.dropdown = el;
                    }
                }, onCsmItemClick: function (e) { return _this.onItemSelected(e); } }, h("slot", null)),
        ];
        var classes = "csm-select " + (this.isOpen ? ' open' : '');
        var element = (h(Host, { class: classes, onClick: function () { return _this.onToggle(); } }, elements));
        var host = this.host;
        try {
            Object.defineProperty(host, 'value', {
                get: function () {
                    return _this.value;
                },
                set: function (newValue) {
                    if (newValue == null) {
                        _this.changeItem(null);
                        return;
                    }
                    var selectedItem = [].filter.apply(host.children, [function (i) { return i.value === newValue; }])[0];
                    if (!selectedItem) {
                        throw new Error('Option value not found: ' + newValue);
                    }
                    _this.changeItem(selectedItem);
                },
            });
        }
        catch (e) { }
        return element;
    };
    Object.defineProperty(CsmSelect.prototype, "host", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}:host{display:block;width:inherit;position:relative;--select-dropdown-width:100%;--select-dropdown-width:inherit}:host .csm-select__dropdown{position:absolute;z-index:30;margin-top:12px;width:var(--select-dropdown-width,inherit)}:host .csm-select__icon{color:rgba(0,0,0,.48);pointer-events:none}:host .csm-select__input{cursor:pointer;background:#fff;border:1px solid #d1d6df;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;padding-left:8px;padding-right:26px;height:36px;width:100%;font-size:15px;line-height:20px;color:rgba(0,0,0,.48)}:host .csm-select__input.active{color:#3c3d40}:host .csm-select__input:focus{border:1px solid;border-color:#4b8ae7;outline:none}:host .csm-select__input:hover{border:1px solid;border-color:#3c3d40}:host .csm-select__input:hover::-webkit-input-placeholder{color:#3c3d40}:host .csm-select__input:hover::-moz-placeholder{color:#3c3d40}:host .csm-select__input:hover:-ms-input-placeholder{color:#3c3d40}:host .csm-select__input:hover::-ms-input-placeholder{color:#3c3d40}:host .csm-select__input:hover::placeholder{color:#3c3d40}:host .csm-select__input:hover~.csm-select__icon{color:#3c3d40}:host .csm-select__icon-left{position:absolute;float:right;margin:26px 0 0 10px;display:block}:host .csm-select__icon-right{position:absolute;margin:10px 0 0 -24px}:host(.open) .csm-select__icon{color:#3c3d40}:host(.open) .csm-select__input{border:1px solid;border-color:#3c3d40}:host(.open) .csm-select__input::-webkit-input-placeholder{color:#3c3d40}:host(.open) .csm-select__input::-moz-placeholder{color:#3c3d40}:host(.open) .csm-select__input:-ms-input-placeholder{color:#3c3d40}:host(.open) .csm-select__input::-ms-input-placeholder{color:#3c3d40}:host(.open) .csm-select__input::placeholder{color:#3c3d40}:host([searchable]) .csm-select__input{padding-left:34px}:host([disabled]) .csm-select__icon{color:#e3e6ec}:host([disabled]) .csm-select__input{cursor:default;border:1px solid #e3e6ec;outline:none}:host([disabled]) .csm-select__input:hover{border:1px solid #e3e6ec}:host([disabled]) .csm-select__input:hover~.csm-select__icon{color:#e3e6ec}:host([disabled]) .csm-select__input::-webkit-input-placeholder{color:rgba(0,0,0,.24)}:host([disabled]) .csm-select__input::-moz-placeholder{color:rgba(0,0,0,.24)}:host([disabled]) .csm-select__input:-ms-input-placeholder{color:rgba(0,0,0,.24)}:host([disabled]) .csm-select__input::-ms-input-placeholder{color:rgba(0,0,0,.24)}:host([disabled]) .csm-select__input::placeholder{color:rgba(0,0,0,.24)}"; },
        enumerable: true,
        configurable: true
    });
    return CsmSelect;
}());
export { CsmSelect as csm_select };
